import type { CourseListResponseCoursesItemInstructorBasicInfo } from './courseListResponseCoursesItemInstructorBasicInfo';
import type { CourseListResponseCoursesItemInstructorSocial } from './courseListResponseCoursesItemInstructorSocial';

/**
 * 강사 정보
 */
export type CourseListResponseCoursesItemInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: CourseListResponseCoursesItemInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: CourseListResponseCoursesItemInstructorSocial;
};
